module.exports = __webpack_public_path__ + "img/slim_cleanstation03.cec13b85.jpg";